/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useEffect } from "react";
import styles from "./affiliatePlans.module.scss";
import {
  Avatar,
  Button,
  Flex,
  Layout,
  Space,
  Table,
  Tag,
  Typography,
  message,
  Popconfirm,
  Input,
  Dropdown,
  Modal,
  Radio,
} from "antd";
import type { TableProps, GetProp, MenuProps, RadioChangeEvent } from "antd";
import PageTitle from "components/PageTitle";
import { T_AffiliatePlan, T_AffiliatePlanType, T_AffiliatePlan_PaymentType } from "dtos/affiliate.plan.dto";
import type { SorterResult, FilterValue } from "antd/es/table/interface";
import { BlogStatusTypes, BlogVisibilityTypes } from "dtos/blog.dto";
import { ApiService } from "api/api.service";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import type { PopconfirmProps } from "antd";
import { TbTrash, TbEdit, TbPlus, TbDots, TbEye } from "react-icons/tb";
import DashboardLayout from "layout/DashboardLayout";
import { BLOG_VISIBILITY_LABELS } from "pages/BlogsAll/BlogsAll";
import { useAppSelector } from "store";
import { RoleTypes } from "dtos/user.dto";
import { AFFILIATE_PLAN_PAYMENT_TYPE_COLOURS, AFFILIATE_PLAN_TYPE_COLOURS } from "utils/constants";
import AffiliatePlansItem from "pages/AffiliatePlansItem";
interface DataType extends T_AffiliatePlan {}

type TablePaginationConfig = Exclude<GetProp<TableProps, "pagination">, boolean>;
interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: SorterResult<any>["field"];
  sortOrder?: SorterResult<any>["order"];
  filters?: Parameters<GetProp<TableProps, "onChange">>[1];
}
const items: MenuProps["items"] = [
  {
    label: "Change Visibility",
    key: "1",
    icon: <TbEye />,
  },
];
const AffiliatePlans = () => {
  const currentUser = useAppSelector((state) => state.user);
  const [serachParams, setSearchParams] = useSearchParams();
  const [filters, setFilters] = useState<{
    page: number;
    limit: number;
  }>({
    page: Number(serachParams.get("page")) === 0 ? 1 : (Number(serachParams.get("page")) ?? 1),
    limit: Number(serachParams.get("limit")) === 0 ? 10 : (Number(serachParams.get("limit")) ?? 10),
  });
  const deleteAffiliatePlans = ApiService.affiliatePlans.useDeleteById();
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedVisibility, setSelectedVisibility] = useState({ init: "", later: "" });
  const [selectedStory, setSelectedStory] = useState("");
  const [highlightedRow, setHighlightedRow] = useState<string | null>(null);
  const navigate = useNavigate();
  const [selectedAffiliatePlans, setSelectedAffiliatePlans] = useState("");
  const [openVisibilityModal, setOpenVisibilityModal] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const affiliatePlansList = ApiService.affiliatePlans.useGetAllPaginated({
    page: filters.page,
    limit: filters.limit,
  });
  const mode = serachParams.get("mode") || undefined;

  const handleMenuClick: MenuProps["onClick"] = (e) => {
    // message.info("Click on menu item.");
    e.key === "1" ? setOpenVisibilityModal(true) : "";
  };

  const columns: TableProps<DataType>["columns"] = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: 230,
      ellipsis: true,
      render: (name: string, record: DataType, index: number) => {
        return (
          <Flex align="center" gap={8}>
            <Avatar
              size={"large"}
              style={{ backgroundColor: "#2c362f", fontSize: "20px", minHeight: 40, minWidth: 40 }}
            >
              {record.name.charAt(0).toUpperCase()}
            </Avatar>
            {/* <Link to={`/dashboard/AffiliatePlans/${record.slug}`}> */}
            <Typography.Title style={{ marginTop: 8 }} level={5} className="w-[180px]">
              {record.name}
            </Typography.Title>
            {/* </Link> */}
          </Flex>
        );
      },
    },
    {
      title: "Plan Type",
      dataIndex: "type",
      width: 150,
      key: "type",

      render: (value: string) => {
        const paymentType = value as T_AffiliatePlanType;
        const type = paymentType.replace(/_/g, " ");
        return <Tag color={AFFILIATE_PLAN_TYPE_COLOURS[paymentType]}>{paymentType}</Tag>;
      },
      filters: Object.keys(T_AffiliatePlanType).map((type) => {
        return {
          text: <Tag color={AFFILIATE_PLAN_TYPE_COLOURS[type as T_AffiliatePlanType]}>{type}</Tag>,
          value: type,
        };
      }),
      onFilter: (value, record) => record.type === value,
      filterSearch: true,
    },
    {
      title: "Payment Type",
      dataIndex: "payment_type",
      width: 150,
      key: "type",

      render: (value: string) => {
        const paymentType = value as T_AffiliatePlan_PaymentType;
        const type = paymentType.replace(/_/g, " ");
        return <Tag color={AFFILIATE_PLAN_PAYMENT_TYPE_COLOURS[paymentType]}>{paymentType}</Tag>;
      },
      filters: Object.keys(T_AffiliatePlan_PaymentType).map((payment_type) => {
        return {
          text: (
            <Tag color={AFFILIATE_PLAN_PAYMENT_TYPE_COLOURS[payment_type as T_AffiliatePlan_PaymentType]}>
              {payment_type}
            </Tag>
          ),
          value: payment_type,
        };
      }),
      onFilter: (value, record) => record.payment_type === value,
      filterSearch: true,
    },

    {
      title: "First Amount",
      dataIndex: "first_amount",
      render: (value) => (value ? value : "-"),
    },
    {
      title: "Recurring Amount",
      dataIndex: "recurring_amount",
      render: (value) => (value ? value : "-"),
    },
    {
      title: "First Percentage",
      dataIndex: "first_percentage",
      render: (value) => (value ? value : "-"),
    },
    {
      title: "Recurring Percentage",
      dataIndex: "recurring_percentage",
      render: (value) => (value ? value : "-"),
    },

    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "start",
      width: 150,
      render: (name: string, record: DataType, index: number) => {
        return (
          <Flex justify="center" align="center" gap={2}>
            {/* <div>
              {record.title.toLocaleLowerCase() === "Default AffiliatePlans".toLocaleLowerCase() ? (
                <span style={{ cursor: "not-allowed" }}>
                  <TbEdit style={{ fontSize: "20px" }} />
                </span>
              ) : (
                <Link to={`/dashboard/AffiliatePlans/${record.slug}`} type="text">
                  <Button icon={<TbEdit style={{ fontSize: "20px" }} />} type="text" />
                </Link>
              )}
            </div> */}
            <Button
              //   onClick={() => navigate(`/dashboard/affiliate-plans/${record._id}`)}
              onClick={() => openModal(record._id)}
              icon={<TbEdit style={{ fontSize: "20px" }} />}
              type="text"
            />
            {currentUser?.role ? (
              [RoleTypes.SUPERADMIN, RoleTypes.ADMIN, RoleTypes.CONTENT_ADMIN].includes(currentUser?.role) ? (
                <Popconfirm
                  title="Delete the affiliate plan"
                  description="Are you sure to delete this affiliate plan?"
                  onConfirm={confirm}
                  onCancel={cancel}
                  okButtonProps={{}}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    onClick={() => setSelectedAffiliatePlans(record._id!)}
                    type="text"
                    disabled={record.name.toLocaleLowerCase() === "Default affiliate plan".toLocaleLowerCase()}
                    icon={<TbTrash style={{ color: "red", fontSize: "20px" }} />}
                  ></Button>
                </Popconfirm>
              ) : null
            ) : null}
          </Flex>
        );
      },
    },
  ];

  const handleTableChange = (pagination: TablePaginationConfig, keyFilters: Record<string, any[] | null>) => {
    setFilters({
      page: pagination.current ?? 1,
      limit: pagination.pageSize ?? 10,
    });
  };
  // const confirm: PopconfirmProps["onConfirm"] = (e) => {
  //   deleteAffiliatePlans.mutate(selectedAffiliatePlans, {
  //     onSuccess: () => {
  //       message.success("AffiliatePlans deleted successfullt");
  //       AffiliatePlansList.refetch();
  //     },
  //     onError: () => {
  //       message.error("Operation failed !!");
  //     },
  //   });
  // };

  const cancel: PopconfirmProps["onCancel"] = (e) => {};

  const confirm = (e: any) => {
    try {
      deleteAffiliatePlans.mutate(selectedAffiliatePlans, {
        onSuccess: () => {
          message.success("Affiliate plans deleted successfully");
          affiliatePlansList.refetch();
        },
        onError: () => {},
      });
    } catch (error: any) {
      console.log(error);
      message.error(`Affiliate plans can't be deleted ${error.errorFields[0].errors[0]}`);
    }
  };

  useEffect(() => {
    if (serachParams.has("page") && serachParams.has("limit")) {
      setFilters({
        ...filters,
        page: Number(serachParams.get("page")) as number,
        limit: Number(serachParams.get("limit")) as number,
      });
    }
  }, [serachParams]);

  const openModal = (id?: string) => {
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (id) {
        params.set("id", id);
      } else {
        params.delete("id");
      }
      return params;
    });
    setIsModalOpen(true);
  };

  return (
    <DashboardLayout
      headerRight={
        <Button
          type="primary"
          //   onClick={() => {
          //     navigate(`/dashboard/create-affiliate-plan`);
          //   }}
          onClick={() => setIsModalOpen(true)}
          icon={<TbPlus />}
        >
          Create Affiliate Plan
        </Button>
      }
    >
      {(isModalOpen || mode) && <AffiliatePlansItem isModalOpen setIsModalOpen={setIsModalOpen} mode={mode} />}
      <PageTitle title="Affiliate Plans" pageTitle={[{ title: "Affiliate Plans" }]} />
      {/* <Input.Search
        placeholder="Search categories..."
        value={searchTerm}
        onChange={handleSearch}
        className={styles.search_container}
      /> */}
      <Table
        virtual
        loading={affiliatePlansList.isLoading}
        columns={columns}
        onChange={handleTableChange}
        dataSource={affiliatePlansList.data?.data}
        pagination={{
          showSizeChanger: true,
          total: affiliatePlansList.data?.totalObjects,
          pageSize: filters.limit,
          current: filters.page,
          onChange: (page, pageSize) => {
            setFilters((prev) => ({ ...prev, page, limit: pageSize }));
          },
        }}
        rowClassName={(record) => (record._id === highlightedRow ? "highlighted-row" : "")}
      />
    </DashboardLayout>
  );
};

export default AffiliatePlans;
